<template>
  <div class="orderContent">
    <a-radio-group
      v-model:value="submitParams.confirmed"
      style="margin-bottom: 20px"
      name="radioGroup"
    >
      <a-radio :value="true">已确认无需修改复诊信息</a-radio>
      <a-radio :value="false">修改复诊信息</a-radio>
      <!-- <a-radio :value="1">已确认无需修改复诊信息</a-radio> -->
      <!-- <a-radio :value="2">修改复诊信息</a-radio> -->
      <!-- <a-radio :value="3">确认患者已复诊</a-radio> -->
    </a-radio-group>
    <div class="remind" v-if="submitParams.confirmed === false">
      <div v-if="needChangehandler === 2">医生意向时间：{{ businessDate }}</div>
      <div>请分别与医生、患者确认时间再填写</div>
    </div>
    <RetreatForm
      :confirmed="submitParams.confirmed"
      v-if="submitParams.confirmed === false"
      ref="reFormRef"
      @showSupplement="() => emit('showSupplement')"
      :newAddSuppleRecord="newAddSuppleRecord"
    />
  </div>
</template>

<script setup>
// import { apiGetCureRevrseByBusiness } from '@/api/workPlace/retreatment'
import { ref, defineExpose, defineProps, computed, reactive, defineEmits } from 'vue'
import RetreatForm from './retreatForm.vue'

const prop = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['showSupplement'])
const submitParams = reactive({
  confirmed: null
})

const needChangehandler = computed(
  () => prop.workOrderGroupInfo.targetWorkOrder.quickDealNavigationRelationAccountType
)

const businessDate = computed(
  () => prop.workOrderGroupInfo.targetWorkOrder.quickDealNavigationBusinessDate
)

const mainformValid = () => {
  return new Promise(resolve => {
    resolve(submitParams)
  })
}
const reFormRef = ref()
const submitForm = () => {
  if (!reFormRef.value) return {}
  return reFormRef.value.submitValidQuery()
}
const passSupplementParams = ctx => {
  console.log(ctx)
  reFormRef.value.changeDate(ctx)
}
defineExpose({
  mainformValid,
  submitForm,
  passSupplementParams
})
</script>
<style lang="scss" scoped>
@import './normalizeOrder.scss';
</style>
